import * as React from 'react'
import { ReactComponentElement } from 'react'
import { RouteDefinition } from '../../utils/type'
import AssetWalletInput from '../../components/AssetWalletInput'
import WalletConnect from '../../components/WalletConnect'

export interface HeaderLinks {
  path?: string
  defaultUrl?: string
  title: string
  image: ReactComponentElement<any>
}

export function withHeader(props: RouteDefinition) {
  const { element: InnerComponent } = props
  return (props: any) => (
    <React.Fragment>
      <WalletConnect />
      <AssetWalletInput />
      <InnerComponent {...props} />
    </React.Fragment>
  )
}
